<template>
  <!-- 物流系统 合约订舱服务商界面 -->
  <div>
    <el-form :model="bookInfoForm" ref="ruleForm" :rules="rules" label-width="100px" class="el_form" label-position="top" v-loading="loading" element-loading-text="加载中···">
      <el-form-item label="类别" size="small">
        <el-input v-model="bookInfoForm.type" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="国家/目的港" size="small">
        <el-input v-model="bookInfoForm.destinationPort" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="起运港" size="small">
        <el-input v-model="bookInfoForm.shipmentPort" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="服务范围" size="small">
        <el-input v-model="bookInfoForm.serviceArea" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="表单状态" size="small">
        <el-input v-model="bookInfoForm.formStatus" readonly disabled placeholder="-"></el-input>
      </el-form-item>
      <el-form-item label="订舱信息" >
        <el-table
          :data="bookInfoForm.bookSpaceInfos"
          border
          style="width: 100%"
          :span-method="contactNoSpanMethod"
        >
          <el-table-column prop="contactNo" label="订舱合同号"></el-table-column>
          <el-table-column prop="spaceDate" label="预装柜日期" width="100"></el-table-column>
          <el-table-column prop="containerType" label="柜型" align="center"></el-table-column>
          <el-table-column prop="containerCount" label="柜量" width="60" align="center"></el-table-column>
          <!--<el-table-column prop="currency" label="币种" width="60" align="center"></el-table-column>-->
          <el-table-column prop="currency" label="币种" width="60" align="center">
            <template slot-scope="scope">
              <span style="color: red; font-weight: bold;">{{ scope.row.currency }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="targetPrice" label="目标价" width="80" align="center"></el-table-column>
          <el-table-column prop="remark" label="特殊要求"></el-table-column>
        </el-table>
      </el-form-item>

      <!-- <el-form-item label="柜量" prop="containerCount" :rules="{ required: true, message: '请输入柜量'}">
        <el-input v-model="bookInfoForm.containerCount" type="number" placeholder="请输入柜量"></el-input>
      </el-form-item> -->

      <div v-for="item in bookInfoForm.bookSpaceInfos" :key="item.id">
          <el-form-item :label="`${item.containerType}柜量`" :rules="{ required: true, message: '请输入柜量'}">
            <el-input v-model="priceArr[item.containerType]" type="number" placeholder="请输入柜量"></el-input>
          </el-form-item>
      </div>

      <el-form-item label="物流公司备注" prop="memo" >
        <el-input v-model="bookInfoForm.memo" type="textarea" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- 柜量填报历史记录 -->
      <el-form-item label="历史填报记录">
        <el-table
          :data="historyTableData"
          border
          class="historyTableStyle"
        >
          <el-table-column type="index" width="60" align="center"></el-table-column>
          <el-table-column prop="offerCount" label="柜量" align="center"></el-table-column>
          <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <div class="footer">
      <el-button round class="footer-btn" type="primary" @click="onSubmit" :disabled="issubmitDisabled">提交</el-button>
      <!-- <el-button round class="footer-btn" @click="checkHistory">查看提交记录</el-button> -->
    </div>

    <el-drawer
      title=""
      direction="btt"
      size="80%"
      :visible.sync="showDrawer"
    >
      <div class="historyTableBox">
        <el-table
          :data="historyTableData"
          border
          class="historyTableStyle"
        >
          <el-table-column type="index" width="60" align="center"></el-table-column>
          <el-table-column prop="offerCount" label="柜量"></el-table-column>
          <el-table-column prop="createTime" label="提交时间"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bookInfoForm: {},
      rules: {},
      showDrawer: false,
      historyTableData: [],
      url: {
        queryFormFormId: '/bookspaceinquiry/queryFormFormId',   //查询本单详情，get，传formid和type
        saveForm: '/bookspaceinquiry/saveForm',   //提交报价单，post，传表单信息
        queryHistoryForm: '/bookspaceinquiry/queryHistoryForm',   //查看报价历史，get
      },
      issubmitDisabled: false,
      loading: true,
      priceArr: []
    }
  },
  created() {
    this.$get(this.url.queryFormFormId, this.$route.query).then(res => {
      if(res.code === 200) {
        this.bookInfoForm = res.result
        this.queryHistoryForm_API()
      } else {
        this.$message.error(res.message)
      }
      this.loading = false
    })
  },
  // 组件内的路由守卫
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem('X-Access-Token')
    next()
  },
  methods: {
    onSubmit() {
      const containerCount = Object.entries(this.priceArr).map(([key, value]) => ({ key, value }));
      this.bookInfoForm.containerCount = containerCount
      // console.log('填写的表单内容: ', this.bookInfoForm)
      let isRequired = Object.values(this.priceArr).length == this.bookInfoForm.bookSpaceInfos.length
      this.$refs.ruleForm.validate((valid) => {
        if (valid && isRequired) {
          // console.log('填写的表单内容: ', this.bookInfoForm, isRequired)
          this.$post(this.url.saveForm, this.bookInfoForm).then(res => {
            if(res.code === 200) {
              this.$message.success('提交成功')
              this.issubmitDisabled = true
              setTimeout(() => {
                  window.close()
              }, 1100)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.warning('有必填项未填写，请填写后再提交！')
          return false;
        }
      });
    },
    checkHistory() {
      this.$get(this.url.queryHistoryForm, { inquiryFromId: this.bookInfoForm.inquiryFromId }).then(res => {
        this.historyTableData = res
      })
      this.showDrawer = true
    },
    // 订舱合同号 行合并
    contactNoSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: this.bookInfoForm?.bookSpaceInfos?.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    queryHistoryForm_API() {
      this.$get(this.url.queryHistoryForm, { inquiryFromId: this.bookInfoForm.inquiryFromId }).then(res => {
        this.historyTableData = res
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el_form {
  padding: 10px 10px 70px;
  /deep/ .el-form-item__label, /deep/ .el-table__cell {
    padding: 0;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
  /deep/ .el-table thead {
    color: rgba(0, 0, 0, .7);
  }
}
.footer {
  width: 100%;
  height: 60px;
  line-height: 60px;
  min-width: 375px;
  max-width: 740px;
  margin: 0 auto;
  background: #fff;
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  text-align: center;
  z-index: 10;
  .footer-btn {
    // width: 48%;
    width: 98%;
  }
}
.historyTableBox {
  margin: 0 16px;
  .historyTableStyle {
    color: #000;
    font-size: 12px;
    td {
      color: #000;
      padding: 4px 0;
      margin: 0;
    }
  }
}
</style>